import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { scrollToTop } from "../../hooks/useSmoothScroll";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 900);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          data-testid="back-to-top"
          onClick={() => scrollToTop()}
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.6 }}
          aria-label="Vissza a tetejére"
          className="fixed bottom-20 right-5 z-40 hidden h-12 w-12 items-center justify-center rounded-full bg-[#0E5A75] text-white shadow-xl shadow-black/20 hover:bg-[#0E5A75] hover:scale-110 transition-transform lg:flex"
        >
          <ArrowUp className="h-5 w-5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
